module.exports = __webpack_public_path__ + "static/imgoutline-ca41bc8975281426202376d6ed20249d.png";